import React from "react";
import RecentPosts from "../sidebar/RecentPosts";
import Search from "../sidebar/Search";
import Categories from "../sidebar/Categories";

const Sidebar = ({ sections }) => {
  const styles = {
    top: {
      marginBottom: 15,
    },
    middle: {
      marginTop: 30,
      marginBottom: 15,
    },
    bottom: {
      marginTop: 30,
    },
  };
  return (
    <>
      {sections.search && (
        <section className="mb-10">
          <Search />
        </section>
      )}
      {sections.recentPosts && (
        <section className="mb-10">
          <RecentPosts />
        </section>
      )}
      <section>
        <Categories />
      </section>
    </>
  );
};

export default Sidebar;
